import React from 'react';

export type BdKeyboardEvent = React.KeyboardEvent<
  HTMLAnchorElement | HTMLDivElement | HTMLSpanElement
>;

export function isKeyboardSpace(e: BdKeyboardEvent) {
  return e.key === ' ' || e.key === 'Spacebar';
}

export function isKeyboardSelect(e: BdKeyboardEvent) {
  return e.key === 'Enter' || isKeyboardSpace(e);
}

export function isKeyboardUpArrow(e: BdKeyboardEvent) {
  return e.key === 'ArrowUp';
}

export function isKeyboardDownArrow(e: BdKeyboardEvent) {
  return e.key === 'ArrowDown';
}

export function isOpenLink(e: BdKeyboardEvent) {
  return e.key === 'Enter';
}

export function isOpenLinkInNewTab(e: BdKeyboardEvent) {
  return (e.ctrlKey || e.metaKey) && isOpenLink(e);
}

export function isKeyboardSelectAll(e: BdKeyboardEvent) {
  return (e.ctrlKey || e.metaKey) && e.key === 'a';
}

export function isKeyboardHome(e: BdKeyboardEvent) {
  return e.key === 'Home';
}

export function isKeyboardEnd(e: BdKeyboardEvent) {
  return e.key === 'End';
}
